// adding new color shades requires an explanatory comment as do all three color shades
/**
 * - shades of green color for successful statuses, accepted, forwarded, saved, etc...
 *
 * - shades of red color for unsuccessful statuses, errors, rejections, etc...
 *
 * - shades of yellow for pending statuses, alerts, in progress etc...
 *
 * - menu icon color - dark grey
 *
 * - delete color for delete icon, logout icons etc...
 *
 * - dialog - dialog buttons color
 *
 * - info - blue color for info data, clickable text etc...
 */
export const colors = {
  POTREBAN_MAT_RED: '#ff000069',
  SUCCESS: '#37b40066',
  SUCCESS_TEXT: '#164900',
  SUCCESS_ICON: '#164900',
  ERROR: '#ff635891',
  ERROR_TEXT: '#931e16',
  ERROR_ICON: '#931e16',
  WARNING: '#ffc00099',
  WARNING_TEXT: '#9f7b0d',
  WARNING_ICON: '#9f7b0d',
  MENU_ICON: '#58585e',
  DELETE: '#ff5552',
  EDIT: '#2f3a3f',
  WHITE: '#fff',
  DIALOG_PRIMARY: '#022760',
  INFO: '#1976d2',
  STATUS_BLUE_BG: '#81D4FA',
  MENU_PRIMARY: '#2f3a3f',
  MENU_DESCRIPTION: '#92929d',
  UPLOAD: '#000000de',
  DARK_PURPLE: '#5f00b3',
  BACKGROUND_PURPLE: '#efdcff',
  RED_BUTTON: '#ff5552',
  GREEN_BUTTON: '#36923a',
  AUTOCOMPLETE: '#888',
  ORANGE: '#ff7c00',
};
